import styled from 'styled-components';
import { themeContract } from '../HeaderFetcher.theme.contract';
export var Header = styled.header.withConfig({
  displayName: "Fallbackstyles__Header",
  componentId: "svk4pb-0"
})(["font-family:", ";position:relative;z-index:61;line-height:normal;-webkit-font-smoothing:antialiased;a{text-decoration:none;color:inherit;}"], function (props) {
  return props.theme.font.family.brand;
});
export var Main = styled.div.withConfig({
  displayName: "Fallbackstyles__Main",
  componentId: "svk4pb-1"
})(["border-bottom:1px solid ", ";width:100%;padding:10px;display:flex;align-items:center;flex-wrap:wrap;@media (min-width:", "){padding:16px;}"], function (props) {
  return props.theme.color.monochrome.base;
}, function (props) {
  return props.theme.size.breakpoint['min-width'].lg;
});
export var TopBar = styled.div.withConfig({
  displayName: "Fallbackstyles__TopBar",
  componentId: "svk4pb-2"
})(["display:flex;background:", ";color:", ";height:30px;justify-content:flex-end;align-items:center;padding-right:15px;padding-left:15px;padding-bottom:1px;max-width:1920px;margin-right:auto;margin-left:auto;"], function (props) {
  return props.theme.color.monochrome.lighter;
}, function (props) {
  return props.theme.color.monochrome.darker;
});
export var TopLink = styled.a.withConfig({
  displayName: "Fallbackstyles__TopLink",
  componentId: "svk4pb-3"
})(["display:flex;align-items:center;color:inherit;svg{margin-top:2px;fill:currentColor;}span{padding-left:10px;}:hover{color:", ";transition:all 0.15s ease-in-out;}:not(:first-child){position:relative;padding-left:15px;margin-left:15px;::before{content:'';position:absolute;width:1px;height:15px;background-color:#ccc;left:0;top:50%;margin-top:-8px;}}"], function (props) {
  return props.theme.color.palette[themeContract[props.theme.channel].link.colorHover];
});
export var LogoContainer = styled.div.withConfig({
  displayName: "Fallbackstyles__LogoContainer",
  componentId: "svk4pb-4"
})(["flex-grow:1;@media (min-width:", "){flex-grow:0;margin-right:30px;}img{height:auto;}"], function (props) {
  return props.theme.size.breakpoint['min-width'].lg;
});
export var LogoLink = styled.a.withConfig({
  displayName: "Fallbackstyles__LogoLink",
  componentId: "svk4pb-5"
})(["display:block;width:49px;height:39px;@media (min-width:", "){width:60px;height:51px;}@media (min-width:", "){width:70px;height:60px;}img{max-width:100%;}"], function (props) {
  return props.theme.size.breakpoint['min-width'].lg;
}, function (props) {
  return props.theme.size.breakpoint['min-width'].xl;
});
export var ShopLink = styled.a.withConfig({
  displayName: "Fallbackstyles__ShopLink",
  componentId: "svk4pb-6"
})(["display:none;align-items:center;align-self:stretch;padding:0 10px;@media (min-width:", "){display:flex;}"], function (props) {
  return props.theme.size.breakpoint['min-width'].lg;
});
export var Search = styled.div.withConfig({
  displayName: "Fallbackstyles__Search",
  componentId: "svk4pb-7"
})(["flex-grow:1;order:3;width:100%;margin-top:10px;@media (min-width:", "){margin-left:45px;margin-right:60px;margin-top:0;width:auto;}"], function (props) {
  return props.theme.size.breakpoint['min-width'].lg;
});
export var Icons = styled.div.withConfig({
  displayName: "Fallbackstyles__Icons",
  componentId: "svk4pb-8"
})(["display:flex;@media (min-width:", "){order:3;}"], function (props) {
  return props.theme.size.breakpoint['min-width'].lg;
});
export var IconLink = styled.a.withConfig({
  displayName: "Fallbackstyles__IconLink",
  componentId: "svk4pb-9"
})(["align-self:stretch;display:flex;flex-direction:column;align-items:center;justify-content:center;width:61px;height:48px;color:inherit;:hover{color:", ";transition:all 0.15s ease-in-out;}svg{width:20px;height:20px;fill:currentColor;}span{font-size:14px;padding-top:6px;}@media (min-width:", "){width:71px;:first-of-type{display:none;}span{font-size:15px;}svg{width:24px;height:24px;}}"], function (props) {
  return props.theme.color.palette[themeContract[props.theme.channel].link.colorHover];
}, function (props) {
  return props.theme.size.breakpoint['min-width'].lg;
});